import { MatchModelBase, SoccerMatchModel, SportMatchModel } from '@nf/types/odds';
import { streamingService } from './streaming.service';
import { smpService } from './smp.service';
import { SiteConfigsSettingsData } from '@nf/types/site';
import { UserInfo } from '@nf/types/account';
import { getMatchIdFromProviderList } from '@/utils/match-util';
import { matchEquals } from '@nf/utils-common/fpw/monadic';
import { scoreboardService } from './scoreboard.service';
import { TimeMachineService } from './timemachine.service';
import { CashoutTypeEnum } from '@/components/icons/cashout-icon';

const isOddsPage = true;

const hasLiveStreamer = (match: MatchModelBase, siteConfigsData?: SiteConfigsSettingsData | null | undefined, user?: UserInfo | null | undefined) => {
	const { hasStreamer } = streamingService.getVideoOptions(match, isOddsPage, siteConfigsData, user);
	return hasStreamer;
}

const hasLiveStreaming = (match: MatchModelBase, siteConfigsData?: SiteConfigsSettingsData | null | undefined, user?: UserInfo | null | undefined) => {
	const { hasVideo } = streamingService.getVideoOptions(match, isOddsPage, siteConfigsData, user);
	return hasVideo;
}

const hasLiveMatch = (match: MatchModelBase, siteConfigsData?: SiteConfigsSettingsData | null | undefined, user?: UserInfo | null | undefined) => {
	const { hasLSports, hasGV } = streamingService.getVideoOptions(match, isOddsPage, siteConfigsData, user);
	return !!hasLSports;
	// hasGV因台中尚未開發完新版gv 因此無意義, 未來完成後可直接使用下面的判斷
	return !!hasLSports || hasGV;
}

const hasStatisticInfo = (match: MatchModelBase, siteConfigsData?: SiteConfigsSettingsData | null | undefined, user?: UserInfo | null | undefined) => {
	if (!match.GameID) return false;

	const {
		hasEsportSportsStatistic,
		hasDecimalWidgets,
		hasSportsStatistic
	} = streamingService.getVideoOptions(match, isOddsPage, siteConfigsData, user);

	return matchEquals(match.GameID)
		.on(43, () => hasEsportSportsStatistic)
		.on(50, () => hasDecimalWidgets)
		.otherwise(() => {
			const providerMatchId = getMatchIdFromProviderList(match, '201');
			return hasSportsStatistic && !!providerMatchId;
		});
}

const hasScoreboard = (match: MatchModelBase) => {
	return scoreboardService.getScoreboardInfo(match);
}

const hasParlay = (match: SportMatchModel) => {
	return match.HasParlay;
}

const hasTimeMachine = (match: MatchModelBase, user?: UserInfo | null | undefined) => {
	return TimeMachineService.HasTimeMachine(match, user);
}

const hasSingleMatchParlay = (match: MatchModelBase, user?: UserInfo | null | undefined) => {
	return smpService.checkSmpAvailability({
		sport: match.GameID,
		id34: match.ID34,
		isLive: match.IsLive,
		isIR: match.Tsp,
		betBuilderStatus: match.BBVD,
		showTime: match.ShowTime
	}, {
		smp1: user?.SMP_1,
		smp2: user?.SMP_2,
		smpLive1: user?.SMPLive_1,
		smpLive2: user?.SMPLive_2
	});
};

const hasFastMarkets = (match: MatchModelBase) => {
	if (match.GameID !== 1) {
		return false;
	}

	return (match as SoccerMatchModel).fast;
}

const hasCashout = (match: MatchModelBase, user?: UserInfo | null | undefined) => {
	const { CO, GameID } = match;

	// user not permit to cash out
	if (user?.UserReject) {
		return false;
	} 
	// match can not cash out in licensee site
	if (!CO || ![CashoutTypeEnum.All, CashoutTypeEnum.LicenseeOnly].includes(CO)) {
		return false;
	} 
	// can not cash out with this sport type
	if (!user?.CashOutSportList || !user.CashOutSportList[GameID]) {
		return false;
	}

	return true;
}

export const matchFilterService = {
	hasLiveStreamer,
	hasLiveStreaming,
	hasLiveMatch,
	hasStatisticInfo,
	hasScoreboard,
	hasParlay,
	hasTimeMachine,
	hasSingleMatchParlay,
	hasFastMarkets,
	hasCashout
};